const styles = theme => ({
  dialogPaper: {
    width: "100%",
  },
  dialogTitle: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
  },
  dialogActionsAction: {
    margin: 0,
  },
  headlineWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    minHeght: 32,
  },
  headline: {
    opacity: 0.6,
    fontSize: "1em",
    display: "inline",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: theme.spacing(1),
  },
  autoComplete: {
    flexGrow: 1,
  },
  autoCompleteInput: {
    padding: "9px 0",
  },
  inputMarginBottom: {
    transform: "translateY(-14px)",
    zIndex: 1,
  },
  zIndex2: {
    zIndex: 2,
  },
  placesAutoCompleteInputInput: {
    "&::placeholder": {
      color: "#000",
      opacity: 0.42,
    },
  },
  input: {
    margin: `0 ${theme.spacing(1)}px`,
    flexBasis: 120,
  },
  citiesWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  closeIcon: {
    width: "0.74em",
    height: "0.74em",
  },
  chipWrapper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  chip: {
    marginRight: theme.spacing(1),
  },
  videoId: {
    color: theme.palette.primary.main,
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  note: {
    display: "flex",
    borderBottom: "1px solid #9c9c9c",
    paddingBottom: 12,
    "&:not(:first-child)": {
      paddingTop: 12,
    },
  },
  lastNote: {
    marginBottom: theme.spacing(3),
  },
  noteContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
  },
  noteFirstLine: {
    display: "flex",
  },
  noteMessageIcon: {
    color: theme.palette.primary.dark,
    width: "0.7em",
    height: "0.7em",
  },
  noteLineText: {
    color: theme.palette.primary.dark,
    fontSize: "0.7em",
    lineHeight: "1.2em",
    padding: `0 ${theme.spacing(1)}px`,
  },
  noteLineArrowIcon: {
    width: "0.6em",
    height: "0.7em",
    cursor: "pointer",
  },
  noteBullet: {
    fontSize: "13px",
    opacity: "0.5",
    lineHeight: "1.2em",
  },
  noteTimeAgo: {
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: "12px",
    padding: "0 6px",
    lineHeight: "1.3em",
  },
  noteNote: {
    color: theme.palette.text.secondary,
  },
  noteAvatar: {
    alignSelf: "center",
  },
  notesInputWrapper: {
    backgroundColor: "#f1f1f1",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    alignItems: "flex-end",
  },
  noteInputUnderline: {
    "&:before": {
      borderBottom: ["none", "!important"],
    },
    "&:after": {
      borderBottom: ["none", "!important"],
    },
  },
  saveNoteButton: {
    alignSelf: "flex-end",
  },
})

export default styles
